import { type ComponentStyleConfig } from "~/foundation/Chakra";

export const Popover = (): Partial<ComponentStyleConfig> => ({
	baseStyle: {
		popper: {
			color: "primary.darkGrey",
		},
		header: {
			borderBottomWidth: 0
		}
	},
});